// Returns today's date string (YYYY-MM-DD) in the user's browser timezone.
// Uses the local getters so it always matches Intl.DateTimeFormat().timeZone.
export const getLocalDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getUserTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York';

export const parseDateString = (dateString) => {
  const [year, month, day] = String(dateString).split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const formatDateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Backward-compatible names used throughout the app.
export const getCentralDate = getLocalDate;

export const getCentralDateObject = () =>
  new Date(`${getLocalDate()}T12:00:00`);
